import { selectDepartments } from "app/containers/AdminConsole/slice";
import { selectTeamsByTeamId } from "app/containers/Global/slice";
import WarningModal from "app/storybookComponents/Modals/WarningModal";
import { useAppSelector } from "utils/redux/hooks";
import { WEEKLY_CHECK_IN_FEATURE_NAME } from "../constants";
import { getPeopleOrPerson } from "utils/helperFunctions";

interface Props {
  teamId?: number;
  departmentId?: number;
  valueChangingTo?: boolean;
  isOpen: boolean;
  onHide: () => void;
  onConfirmClick: () => void;
}

const ToggleCheckInFeatureWarningModal = ({
  valueChangingTo,
  isOpen,
  onHide,
  onConfirmClick,
  departmentId,
  teamId,
}: Readonly<Props>) => {
  const departments = useAppSelector(selectDepartments);
  const teams = useAppSelector(selectTeamsByTeamId);

  const getWarningTitle = () => {
    const enableOrDisable = valueChangingTo ? "Enable" : "Disable";
    let entityName = "";

    if (departmentId) {
      const department = departments[departmentId];
      let departmentName = department?.name ?? "";
      if (!departmentName?.toLowerCase().includes("department")) {
        departmentName += " Department";
      }
      entityName = departmentName;
    } else if (teamId) {
      const team = teams[teamId];
      let teamName = team?.teamName ?? "";
      if (!teamName?.toLowerCase().includes("team")) {
        teamName += " Team";
      }
      entityName = teamName;
    }
    const entityLower = entityName.toLowerCase();

    const includeThe =
      entityLower.includes("team") || entityLower.startsWith("the");

    return `${enableOrDisable} ${WEEKLY_CHECK_IN_FEATURE_NAME}s for everyone in ${
      includeThe ? "the " : ""
    }${entityName}?`;
  };

  const getTeamOrDepartment = () => {
    if (departmentId) {
      return "department";
    }
    if (teamId) {
      return "team";
    }
    return "";
  };

  const getCount = () => {
    if (departmentId) {
      const department = departments[departmentId];
      return department?.teams?.length ?? 0;
    }
    if (teamId) {
      const team = teams[teamId];
      return team?.teamMemberIds?.length ?? 0;
    }
    return 0;
  };

  const getWarningMessage = () => {
    const count = getCount();
    if (valueChangingTo) {
      return `An email will be sent to ${count} ${getPeopleOrPerson(
        count
      )} in this ${getTeamOrDepartment()} asking them to check on work progress, share how they’re feeling, and report any successes or challenges at the end of each check-in period.`;
    }
    return `Emails may no longer be sent to ${count} ${getPeopleOrPerson(
      count
    )} in this ${getTeamOrDepartment()} asking them to check on work progress, share how they’re feeling, and report any successes or challenges at the end of each check-in period.`;
  };

  return (
    <WarningModal
      isOpen={isOpen}
      hideModal={onHide}
      onConfirmClick={onConfirmClick}
      modalTitle="Confirmation"
      warningTitle={getWarningTitle()}
      isDanger={false}
      customButtonText={valueChangingTo ? "Enable" : "Disable"}
      warningMessage={getWarningMessage()}
    />
  );
};

export default ToggleCheckInFeatureWarningModal;
